module.exports = __webpack_public_path__ + "img/module-dependents.54b4221a.svg";